module.exports = __webpack_public_path__ + "857cc53acb9f68b1cfb49521e847db69.svg";